import getAPIUrl from '../../../config';
import { getApi } from '../../../utils/apiCalls';
import removeFalsyValues from '../../../utils/customMethods';
import { ContentApiProps } from './types';

const getArticles = async (data?: ContentApiProps): Promise<Error | any> => {
    try {
        const result = getApi(
            `${getAPIUrl()}/admins/articles`,
            data
                ? removeFalsyValues({
                      size: data.size,
                      page: data.currentPage,
                      sort: data.sort,
                      order: data.order,
                      title: data.searchText,
                      authors: data.authors.filter((a) => a.checked).map((a) => a.id),
                      categories: data.categories.filter((c) => c.checked).map((c) => c.id),
                      is_visible: data.selectedStatus && data.selectedStatus === 'active',
                  })
                : undefined,
        );
        return result;
    } catch (error: unknown) {
        const err = error as Error;
        return err;
    }
};

export default getArticles;
